import React from 'react'
import { DRAWER_KEY } from 'app-constants'
import { AddressChangeDrawer } from './address-change'
import { EmailDrawer } from './email'
import { PlanDrawer } from './plan'
import { PhoneDrawer } from './phone'
import { CallsDrawer } from './calls'
import { MyServicesDrawer } from './my-services'
import { ModemDrawer } from './modem'
import { PasswordDrawer } from './password'
import { CompleteSignupDrawer } from './complete-signup'
import { DueDateDrawer } from './due-date'
import { MessagesDrawer } from './messages'
import { ActivationPendingDrawer } from './activation-pending'
import { ConfirmServiceScheduleDrawer } from './confirm-service-schedule'
import { FaqDrawer } from './faq'
import { NegotiationDrawer } from './negotiation'
import { ServiceOrdersDrawer } from './service-orders'
import { UnlockAccountDrawer } from './unlock-account'
import { ProtocolDrawer } from './protocol'
import { NewVirtualSupport } from './new-virtual-support'
import { ObjectionDrawer } from './objections'
import { UnduePaymentDrawer } from './undue-payment'
import { StoreDrawer } from './store'
import { WifiBestPracticesDrawer } from './wifi-best-practices'
import { FidelityDrawer } from './fidelity'
import { DetailsSvaDrawer } from './details-sva'
import { PaymentsDrawer } from './payments'
import { Invoices } from './invoices'
import { AISupport } from './ai-support'
import { OsBlockDrawer } from './os-block'

export function DrawerTemplate() {
  return {
    [DRAWER_KEY.ACTIVATION_PENDING]: <ActivationPendingDrawer />,
    [DRAWER_KEY.ADDRESS_CHANGE]: <AddressChangeDrawer />,
    [DRAWER_KEY.CALLS]: <CallsDrawer />,
    [DRAWER_KEY.COMPLETE]: <CompleteSignupDrawer />,
    [DRAWER_KEY.CONFIRM_SERVICE_SCHEDULE]: <ConfirmServiceScheduleDrawer />,
    [DRAWER_KEY.DUE_DATE]: <DueDateDrawer />,
    [DRAWER_KEY.EMAIL]: <EmailDrawer />,
    [DRAWER_KEY.FAQ]: <FaqDrawer />,
    [DRAWER_KEY.MESSAGES]: <MessagesDrawer />,
    [DRAWER_KEY.MODEM]: <ModemDrawer />,
    [DRAWER_KEY.NEGOTIATION]: <NegotiationDrawer />,
    [DRAWER_KEY.PASSWORD]: <PasswordDrawer />,
    [DRAWER_KEY.PHONE]: <PhoneDrawer />,
    [DRAWER_KEY.PLAN]: <PlanDrawer />,
    [DRAWER_KEY.SERVICES]: <MyServicesDrawer />,
    [DRAWER_KEY.SERVICE_ORDERS]: <ServiceOrdersDrawer />,
    [DRAWER_KEY.UNLOCK_ACCOUNT]: <UnlockAccountDrawer />,
    [DRAWER_KEY.VIRTUAL_SUPPORT]: <NewVirtualSupport />,
    [DRAWER_KEY.PROTOCOL]: <ProtocolDrawer />,
    [DRAWER_KEY.OBJECTIONS]: <ObjectionDrawer />,
    [DRAWER_KEY.UNDUE_PAYMENT]: <UnduePaymentDrawer />,
    [DRAWER_KEY.STORE]: <StoreDrawer />,
    [DRAWER_KEY.WIFI_BEST_PRACTICES]: <WifiBestPracticesDrawer />,
    [DRAWER_KEY.FIDELITY]: <FidelityDrawer />,
    [DRAWER_KEY.DETAILS_SVA]: <DetailsSvaDrawer />,
    [DRAWER_KEY.PAYMENTS]: <PaymentsDrawer />,
    [DRAWER_KEY.INVOICES]: <Invoices />,
    [DRAWER_KEY.AI_SUPPORT]: <AISupport />,
    [DRAWER_KEY.OS_BLOCK]: <OsBlockDrawer />,
  }
}
